import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {MoviesObj} from 'common/src/modules/movieEditor/movieEditor.types';
import {PRECOMP_PREVIEW_FORMAT} from 'common/src/modules/movieEditor/movieEditor.consts';
import {setFormatsChanged, updateMovies} from '../formatMovies.slice';
import {movieCompsHistoryActions} from '../movieCompsHistory.service';
import {RootState} from 'common/src/redux/store';
interface UpdateMoviesParams {
  moviesUpdate: MoviesObj;
  replaceState?: boolean;
  activeFormat: string;
}

const updateMoviesThunk = createAsyncThunk(
  `${BreadcrumbName.AdBuilder}/updateMovies`,
  async (
    {moviesUpdate, replaceState = false, activeFormat}: UpdateMoviesParams,
    {dispatch, getState},
  ): Promise<void> => {
    const state = getState() as RootState;

    const currentMovies = state.creativeTemplatePage.formatMovies.movies;

    if (!replaceState) {
      movieCompsHistoryActions.push(currentMovies);
    }

    // Dispatch the update with history management
    dispatch(updateMovies(moviesUpdate));

    // Get activeFormat from URL search params and formatsChanged from state
    const formatsChanged = state.creativeTemplatePage.formatMovies.formatsChanged;

    // Update formats changed if activeFormat exists
    if (
      activeFormat &&
      activeFormat !== PRECOMP_PREVIEW_FORMAT &&
      !formatsChanged.includes(activeFormat)
    ) {
      dispatch(setFormatsChanged([...formatsChanged, activeFormat]));
    }
  },
);

export default updateMoviesThunk;
